<template>
  <div class="page-content family-members">
    <div class="row">
      <div class="col-sm-6 col-12">
        <add-family-member />
        <remove-loved-one-email />
      </div>
      <div class="col-sm-6 col-12">
        <send-test-sms />
        <assign-loved-one-to-caller />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <loved-one-search />
        <caller-active-hours />
        <loved-one-call-sms-email-options />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, defineAsyncComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const AddFamilyMember = defineAsyncComponent(() => import('@/components/Main/Family/AddFamilyMember.vue') as any);

const SendTestSms = defineAsyncComponent(() => import('./FamilyMember/SendTestSms.vue') as any);

const AssignLovedOneToCaller = defineAsyncComponent(() => import('./FamilyMember/AssignLovedOneToCaller.vue') as any);

const LovedOneSearch = defineAsyncComponent(() => import('./FamilyMember/LovedOneSearch.vue') as any);

const CallerActiveHours = defineAsyncComponent(() => import('./FamilyMember/CallerActiveHours.vue') as any);

const LovedOneCallSmsEmailOptions = defineAsyncComponent(() => import('./FamilyMember/LovedOneCallSmsEmailOptions.vue') as any);

const RemoveLovedOneEmail = defineAsyncComponent(() => import('./FamilyMember/RemoveLovedOneEmail.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();

  util.moveScrollComponent(hash);
});
</script>
